module.exports = __webpack_public_path__ + "static/media/190x190px_express.38e4124d.png";